import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {withToastManager} from "react-toast-notifications";
import {isPasswordValid} from "../../../../utils/BubblyUtils";
import {buildCSSFormGroupInput} from "../../../../utils/BubblyUIUtils";
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";
import {saveUserActivationData} from "../../../../slices/userSlice";
import {calculateFingerPrint} from "../../../../utils/UserUtils";

function PasswordResetNewPass(props) {
    const [password, updatePassword] = useState("");
    const [passwordValid, updatePasswordValid] = useState();
    const [showPassword, updateShowPassword] = useState(false);

    useEffect(() => {
        AuthenticationService.checkHashIsValid(props.resetData.userId, props.resetData.resetHash, null, () => {
            props.hashInvalidAction();
        });
    }, []);

    function onPasswordChange(event) {
        const password = event.target.value;
        updatePassword(password);
        const passwordValid = isPasswordValid(password);
        updatePasswordValid(passwordValid);
        buildCSSFormGroupInput(event, "passwordResetNewPassFormGroup", "passwordResetNewPassFormGroupError", passwordValid);
    }

    function toggleShowPassword() {
        updateShowPassword(!showPassword);
    }

    function onNewPassAction(event) {
        event.preventDefault();

        const changePassErrCallback = () => {
            props.toastManager.add("Error while trying to change the password", {
                appearance: 'error'
            });

        };

        const loginErrCallback = (error) => {
            props.toastManager.add("Error while trying to login to the account", {
                appearance: 'error'
            });
        };
        calculateFingerPrint(browserFingerprint => {
            AuthenticationService.changePassword(props.resetData.userId, password,browserFingerprint,props.resetData.resetHash, (success) => {
                AuthenticationService.defaultLogin(props.resetData.email, password, null, null,
                    (success) => {
                        props.saveUserActivationData(success.data.user_id, success.data.token, success.data.level);
                        props.history.push('/surveys');
                    }, loginErrCallback);
            }, changePassErrCallback);
        })


    }

    return (
        <div className="container">
            <h1 className="pt-md pb-xl">Save a new password</h1>
            <p className="color--darkgray pb-xl text-center">Enter a new password of at least 8 characters below.</p>
            <form action="" className="form pt-sm" onSubmit={onNewPassAction}>
                <div className="form__group" id="passwordResetNewPassFormGroup">
                    <div className="form__group__input">
                        <input className="form__group__input__text password-input-js"
                               type={showPassword ? "text" : "password"}
                               placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;"
                               onChange={onPasswordChange}/>
                        <span className="form__group__input__toggle" onClick={toggleShowPassword}></span>
                        <span className="form__group__input__icon"><img src="./assets/img/login_page/lock.png"
                                                                        alt=""/></span>
                    </div>
                    <span className="form__group__error form__group__error--email" id="passwordResetNewPassFormGroupError">Please enter at least 8 characters</span>
                </div>

                <div className="cta__wrapp pv-xs">
                    <input type="submit"
                           id="passwordResetNewPassSubmit"
                           className={passwordValid ? "cta--normal cta--fullwidth cta--notransform" : "cta--normal cta--fullwidth cta--notransform cta--soft-disabled"}
                           disabled={!passwordValid}
                           value={"RESET PASSWORD"}/>
                </div>
                <div className="cta__wrapp pv-xs">
                    <Link to="/login" className="cta--text cta--notransform">Back to log in</Link>
                </div>
            </form>
        </div>
    );
}

const mapDispatchToProps = { saveUserActivationData };

export default connect(null, mapDispatchToProps)(withRouter(withToastManager(PasswordResetNewPass)));
